<template>
  <div class="login-register-container">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <LoginForm
            v-if="userflow === 'login'"
            v-on:evt-on-click-create-account="setUserFlow('register')"
            v-on:evt-auth-success="onAuthSuccess()"
          ></LoginForm>
          <RegisterForm
              v-if="userflow === 'register'"
              v-on:evt-on-click-i-have-an-account="setUserFlow('login')"
              v-on:evt-auth-success="onAuthSuccess()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
export default {
  components: { RegisterForm, LoginForm },
  data() {
    return {
      userflow: "login"
    };
  },
  props: {},
  computed: {
    // map store state to local computed properties:
    ...mapState({
      // id: state => state.book.id
    }),
    // map store getters to local computed properties:
    ...mapGetters(["userIsLoggedIn"])
  },
  methods: {
    // map component methods to store.dispatch calls
    ...mapActions([]),
    setUserFlow(inStrUserFlow) {
      this.userflow = inStrUserFlow;
    },
    onAuthSuccess() {
      // It's expected that whoever calls us passes in a redirect value,
      // so that we can take the user to the next page in their workflow.
      if (this.$route.query.redirect) {
        console.log(
          `[LoginScene] - Redirecting to ${this.$route.query.redirect}`
        );
        this.$router.push({ path: this.$route.query.redirect });
      } else {
        // no redirect was given - default to the storefront
        this.$router.push({ name: "storefront" });
      }
    }
  },
  mounted() {
    // If the login page is being shown and we're already logged in
    // let's navigate away, since this workflow doesn't make sense
    if (this.userIsLoggedIn) {
      this.onAuthSuccess();
    }
  }
};
</script>
<style scoped>
.login-register-container {
  padding: 2em;
  flex: 1 0 auto;
}
.v-divider {
  border-right: 1px solid #eae9e9;
}
@media only screen and (max-width: 600px) {
  .v-divider {
    border-right: none;
  }
}
</style>
